'use client'

import { useSyncExternalStore } from 'react'

function subscribe(onChange: () => void): () => void {
  window.addEventListener('hashchange', onChange)
  return () => window.removeEventListener('hashchange', onChange)
}

function getSnapshot(): string {
  const raw = window.location.hash.slice(1)
  try {
    return decodeURIComponent(raw)
  } catch {
    return raw
  }
}

// En servidor no hay hash (no viaja en la petición): cadena vacía, y el
// primer render de cliente coincide con el HTML del servidor; React relee
// `getSnapshot` tras hidratar y re-renderiza si había hash.
function getServerSnapshot(): string {
  return ''
}

/**
 * Fragmento actual de la URL (sin `#`, decodificado), reactivo a
 * `hashchange`. Sirve para abrir/enfocar el elemento al que apunta un enlace
 * con ancla (p. ej. una pregunta de las FAQs).
 *
 * Solo reacciona a navegaciones que disparan `hashchange` (enlaces `<a>`
 * nativos, atrás/adelante). `next/link` hace scroll al `#id` pero no emite
 * ese evento, así que los enlaces que deban activar un ancla en la misma
 * página tienen que ser `<a>` nativos.
 */
export function useLocationHash(): string {
  return useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot)
}
